"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from "react";
import { useTranslations } from "next-intl";
import VerificationCode from "@/app/components/UI/VerificationCode";
import { TWO_FACTOR_ERROR_KEYS } from "@/app/apiServices/security/helpers";
import { p2e } from "@/app/utils/replaceNumber";
import type { TwoFactorCodeFieldProps } from "@/app/components/Dashboard/Security/security.interface";
const COMPACT_BOXES = "!w-10 !h-12 xl:!w-12 xl:!h-12";
export default function TwoFactorCodeField(t0) {
  const $ = _c(26);
  const {
    label,
    helper,
    value,
    onChange,
    errorKind,
    expiresAt,
    onResend,
    onNoAccess,
    compact: t1
  } = t0;
  t1 === undefined ? false : t1;
  const t = useTranslations();
  const [timerDone, setTimerDone] = useState(false);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setTimerDone(false);
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== expiresAt) {
    t3 = [expiresAt];
    $[1] = expiresAt;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  useEffect(t2, t3);
  const t4 = label ?? "";
  let t5;
  if ($[3] !== onChange) {
    t5 = next => onChange(p2e(next));
    $[3] = onChange;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const t6 = Boolean(errorKind);
  let t7;
  if ($[5] !== errorKind || $[6] !== t) {
    t7 = errorKind ? t(TWO_FACTOR_ERROR_KEYS[errorKind]) : undefined;
    $[5] = errorKind;
    $[6] = t;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t6 || $[9] !== t7) {
    t8 = {
      hasError: t6,
      message: t7
    };
    $[8] = t6;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== expiresAt || $[12] !== onResend || $[13] !== timerDone) {
    t9 = expiresAt ? {
      visible: true,
      target: expiresAt,
      completed: timerDone,
      onComplete: () => setTimerDone(true),
      onResend: () => onResend?.()
    } : undefined;
    $[11] = expiresAt;
    $[12] = onResend;
    $[13] = timerDone;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== onNoAccess || $[16] !== t) {
    t10 = onNoAccess ? {
      label: t("security.TFA_NO_ACCESS"),
      onClick: onNoAccess
    } : undefined;
    $[15] = onNoAccess;
    $[16] = t;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== helper || $[19] !== t10 || $[20] !== t4 || $[21] !== t5 || $[22] !== t8 || $[23] !== t9 || $[24] !== value) {
    t11 = <VerificationCode inputLabel={t4} helperText={helper} value={value} onChange={t5} inputClassName="mt-6" error={t8} timer={t9} secondaryAction={t10} />;
    $[18] = helper;
    $[19] = t10;
    $[20] = t4;
    $[21] = t5;
    $[22] = t8;
    $[23] = t9;
    $[24] = value;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  return t11;
}